import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Check, Clock, Loader2 } from 'lucide-react';
import { InlineWidget } from 'react-calendly';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const CALENDLY_URL = "https://calendly.com/livejobs/beratung?back=1&month=2026-06";

const u = (id) => `https://images.unsplash.com/photo-${id}?w=400&h=300&fit=crop`;

const QUESTIONS = [
  {
    id: 'ziel',
    number: 1,
    question: 'Was ist Ihre größte Recruiting-Herausforderung?',
    type: 'list',
    multi: false,
    options: [
      { key: 'A', label: 'Zu wenig Bewerbungen auf offene Stellen' },
      { key: 'B', label: 'Zu wenig qualifizierte Kandidaten' },
      { key: 'C', label: 'Bewerber springen im Prozess ab' },
      { key: 'D', label: 'Zu lange Time-to-Hire' },
      { key: 'E', label: 'Kein klares Arbeitgeber-Profil / Employer Brand' },
    ],
  },
  {
    id: 'branche',
    number: 2,
    question: 'In welcher Branche ist Ihr Unternehmen tätig?',
    type: 'image-cards',
    multi: false,
    options: [
      { key: 'A', label: 'Gesundheitswesen / Pflege', img: u('1579684385127-1ef15d508118') },
      { key: 'B', label: 'Industrie / Produktion', img: u('1504868584819-f8e8b4b6d7e3') },
      { key: 'C', label: 'IT / Technologie', img: u('1460925895917-afdab827c52f') },
      { key: 'D', label: 'Öffentliche Verwaltung', img: u('1642522029691-029b5a432954') },
      { key: 'E', label: 'Handwerk / Bau', img: u('1504307651254-35680f356dfd') },
      { key: 'F', label: 'Andere Branche', img: u('1762341119317-fb5417c18407') },
    ],
  },
  {
    id: 'unternehmensgroesse',
    number: 3,
    question: 'Wie viele Mitarbeitende hat Ihr Unternehmen?',
    type: 'cards',
    multi: false,
    options: [
      { key: 'A', label: '10-30' },
      { key: 'B', label: '31-100' },
      { key: 'C', label: '101-500' },
      { key: 'D', label: '501-2.000' },
      { key: 'E', label: '2.000+' },
    ],
  },
  {
    id: 'offene_stellen',
    number: 4,
    question: 'Wie viele offene Stellen haben Sie aktuell?',
    type: 'cards',
    multi: false,
    options: [
      { key: 'A', label: '1-3' },
      { key: 'B', label: '4-10' },
      { key: 'C', label: '11-25' },
      { key: 'D', label: '25+' },
    ],
  },
  {
    id: 'bisherige_massnahmen',
    number: 5,
    question: 'Was nutzen Sie aktuell, um Mitarbeitende zu finden?',
    subtitle: 'Mehrfachauswahl möglich',
    type: 'image-cards',
    multi: true,
    options: [
      { key: 'A', label: 'Stellenportale (Jobs.ch etc.)', img: u('1499750310107-5fef28a66643') },
      { key: 'B', label: 'Eigene Karriereseite', img: u('1460925895917-afdab827c52f') },
      { key: 'C', label: 'Social Media (LinkedIn etc.)', img: u('1762340274849-87b569b2f0c8') },
      { key: 'D', label: 'Personalvermittler / Headhunter', img: u('1642522029691-029b5a432954') },
      { key: 'E', label: 'Empfehlungen / Netzwerk', img: u('1758520144427-ddb02ac74e9d') },
      { key: 'F', label: 'Noch nicht viel', img: u('1762341119317-fb5417c18407') },
    ],
  },
  {
    id: 'video_vorhanden',
    number: 6,
    question: 'Haben Sie bereits Employer Branding Videos?',
    type: 'list',
    multi: false,
    options: [
      { key: 'A', label: 'Ja, professionell produzierte Videos' },
      { key: 'B', label: 'Ja, aber nur selbst gedreht / Handy-Qualität' },
      { key: 'C', label: 'Nein, noch keine Videos' },
      { key: 'D', label: 'Videos geplant, aber noch nicht umgesetzt' },
    ],
  },
  {
    id: 'interesse',
    number: 7,
    question: 'Was interessiert Sie am meisten?',
    subtitle: 'Mehrfachauswahl möglich',
    type: 'list',
    multi: true,
    options: [
      { key: 'A', label: 'Employer Branding Videos für die Karriereseite' },
      { key: 'B', label: 'Social Media Reels / Kurzvideos' },
      { key: 'C', label: 'Social Recruiting Kampagne (bezahlte Werbung)' },
      { key: 'D', label: 'Komplettpaket: Videos + Kampagne' },
      { key: 'E', label: 'Möchte erst beraten werden' },
    ],
  },
  {
    id: 'zeitrahmen',
    number: 8,
    question: 'Wann möchten Sie mit dem Recruiting starten?',
    type: 'list',
    multi: false,
    options: [
      { key: 'A', label: 'Sofort — wir haben dringenden Bedarf' },
      { key: 'B', label: 'In den nächsten 2-4 Wochen' },
      { key: 'C', label: 'In den nächsten 1-3 Monaten' },
      { key: 'D', label: 'Wir informieren uns erstmal' },
    ],
  },
  {
    id: 'email',
    number: 9,
    question: 'Ihre geschäftliche E-Mail Adresse *',
    type: 'email',
    placeholder: 'name@unternehmen.ch',
    required: true,
  },
  {
    id: 'kontakt',
    number: 10,
    question: 'Wie erreichen wir Sie am besten? *',
    type: 'contact',
    required: true,
  },
];


/* =========== IMAGE CARD =========== */
function ImageCard({ opt, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid={`rq-option-${opt.key}`}
      className={`text-left rounded-xl overflow-hidden border-2 transition-all cursor-pointer ${
        selected ? 'border-[#2E7CF6] shadow-md' : 'border-slate-200 hover:border-slate-300'
      }`}
    >
      <div className="w-full h-16 sm:h-24 overflow-hidden bg-slate-100">
        <img src={opt.img} alt={opt.label} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="px-3 py-2 sm:px-4 sm:py-3 flex items-center gap-2">
        <span className={`inline-flex items-center justify-center w-5 h-5 rounded text-[10px] font-bold shrink-0 ${
          selected ? 'bg-[#2E7CF6] text-white' : 'bg-slate-200 text-slate-500'
        }`}>{opt.key}</span>
        <span className="text-xs sm:text-sm font-medium text-slate-900 leading-tight">{opt.label}</span>
      </div>
    </button>
  );
}


/* =========== PRELANDER =========== */
function Prelander({ onStart }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center relative overflow-hidden bg-white" data-testid="rq-prelander">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full opacity-[0.04]"
        style={{ background: 'radial-gradient(circle, #2E7CF6 0%, transparent 70%)' }}
      />
      <div className="relative z-10 max-w-xl">
        <div className="mb-10">
          <span className="text-slate-900 font-black text-xl tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>VALORYX</span>
        </div>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#2E7CF6]/20 bg-[#2E7CF6]/5 mb-8">
          <Clock className="w-3.5 h-3.5 text-[#2E7CF6]" />
          <span className="text-xs font-bold text-[#1B5FD4] tracking-wide">Dauert nur 90 Sekunden</span>
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-[1.1] mb-5 font-black tracking-tighter" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Finden Sie heraus, wie Sie schneller die richtigen Mitarbeitenden gewinnen
        </h1>
        <p className="text-base text-slate-600 leading-relaxed max-w-md mx-auto mb-10" style={{ fontFamily: "'Manrope', sans-serif" }}>
          Beantworten Sie wenige kurze Fragen — wir zeigen Ihnen, welche Recruiting-Strategie am besten zu Ihrem Unternehmen passt.
        </p>
        <button onClick={onStart} data-testid="rq-start-btn"
          className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#2E7CF6] to-[#1B5FD4] text-white font-bold text-base rounded-md hover:opacity-90 transition-all cursor-pointer"
          style={{ fontFamily: "'Manrope', sans-serif" }}>
          Jetzt starten <ArrowRight className="w-5 h-5" />
        </button>
        <p className="text-xs text-slate-400 mt-4">Kostenlos & unverbindlich</p>
      </div>
      <footer className="absolute bottom-6 left-0 right-0 text-center text-slate-300 text-xs px-6">
        2026 VALORYX.{' '}
        <Link to="/impressum" className="underline hover:text-slate-500">Impressum</Link>
        {' - '}
        <Link to="/datenschutz" className="underline hover:text-slate-500">Datenschutzerklärung</Link>
      </footer>
    </div>
  );
}


/* =========== MAIN QUIZ =========== */
export default function RecruitingQuizPage() {
  const [started, setStarted] = useState(false);
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [emailValue, setEmailValue] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactLastName, setContactLastName] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Load Recruiting Pixel on mount
  useEffect(() => {
    if (!window._recruitingPixelLoaded) {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1558624095784812');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      window._recruitingPixelLoaded = true;
    } else if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, []);

  // Fire Lead event on submit
  useEffect(() => {
    if (submitted && typeof window.fbq === 'function') {
      window.fbq('track', 'Lead');
    }
  }, [submitted]);

  const current = QUESTIONS[step];
  const progress = ((step + 1) / QUESTIONS.length) * 100;

  const selectOption = useCallback((questionId, key, multi) => {
    setAnswers(prev => {
      if (multi) {
        const current = prev[questionId] || [];
        return { ...prev, [questionId]: current.includes(key) ? current.filter(k => k !== key) : [...current, key] };
      }
      return { ...prev, [questionId]: key };
    });
    if (!multi) {
      setTimeout(() => setStep(s => Math.min(s + 1, QUESTIONS.length - 1)), 350);
    }
  }, []);

  const handleSubmit = async () => {
    const newErrors = {};
    if (!contactName.trim()) newErrors.name = 'Pflichtfeld';
    if (!contactLastName.trim()) newErrors.lastName = 'Pflichtfeld';
    if (!contactPhone.trim()) newErrors.phone = 'Pflichtfeld';
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }

    const finalAnswers = { ...answers, kontakt: { name: contactName, lastName: contactLastName, phone: contactPhone } };

    setSubmitting(true);
    try {
      await fetch(`${API_URL}/api/recruiting-quiz`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...finalAnswers, email: emailValue, id: crypto.randomUUID(), submitted_at: new Date().toISOString(), source: 'recruiting' }),
      });
    } catch (e) { console.error('Submit error:', e); }
    setSubmitting(false);
    setSubmitted(true);
  };

  if (!started) return <Prelander onStart={() => setStarted(true)} />;

  if (submitted) {
    return (
      <div className="min-h-screen relative overflow-hidden bg-white" data-testid="rq-thank-you">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full opacity-[0.04]"
          style={{ background: 'radial-gradient(circle, #2E7CF6 0%, transparent 70%)' }}
        />
        <div className="relative z-10 max-w-3xl mx-auto px-6 pt-16 pb-8 text-center">
          <div className="w-14 h-14 rounded-full bg-[#2E7CF6]/10 border border-[#2E7CF6]/20 flex items-center justify-center mx-auto mb-6">
            <Check className="w-7 h-7 text-[#2E7CF6]" />
          </div>
          <h1 className="text-2xl sm:text-3xl text-slate-900 leading-tight mb-3 font-black tracking-tighter" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Vielen Dank, {contactName} {contactLastName}!
          </h1>
          <p className="text-base text-slate-600 leading-relaxed mb-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Wir haben Ihre Angaben erhalten. Buchen Sie jetzt direkt Ihr kostenloses Beratungsgespräch:
          </p>
        </div>
        <div className="relative z-10 max-w-3xl mx-auto px-6 pb-10">
          <div className="rounded-2xl overflow-hidden border border-slate-200" data-testid="rq-calendly-embed">
            <InlineWidget
              url={CALENDLY_URL}
              prefill={{
                name: `${contactName} ${contactLastName}`.trim(),
                email: emailValue,
              }}
              styles={{ height: '660px', minWidth: '320px' }}
              pageSettings={{
                backgroundColor: 'ffffff',
                hideEventTypeDetails: false,
                hideLandingPageDetails: false,
                primaryColor: '2E7CF6',
                textColor: '1e293b',
              }}
            />
          </div>
          <div className="text-center mt-6">
            <a href="/recruiting" className="inline-block px-6 py-2.5 border border-slate-200 text-slate-500 text-sm rounded-md hover:bg-slate-50 transition-all">
              Zurück zur Übersicht
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white relative" style={{ fontFamily: "'Manrope', sans-serif" }}>
      {/* Progress */}
      <div className="fixed top-0 left-0 right-0 h-1 bg-slate-100 z-50">
        <div className="h-full bg-gradient-to-r from-[#2E7CF6] to-[#1B5FD4] rounded-r-full transition-all duration-500" style={{ width: `${progress}%` }} />
      </div>

      {/* Header */}
      <div className="fixed top-4 left-6 right-6 z-40 flex items-center justify-between">
        <span className="text-slate-900 font-black text-lg tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>VALORYX</span>
        <span className="text-sm text-slate-400">{step + 1} / {QUESTIONS.length}</span>
      </div>

      {/* Question */}
      <div className="min-h-screen flex items-start md:items-center justify-center px-6 py-20 md:py-24">
        <div className="w-full max-w-2xl" key={step}>
          {/* Question header */}
          <div className="mb-5 sm:mb-8">
            <span className="text-[#2E7CF6] text-sm font-bold">{current.number}.</span>
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mt-1 leading-snug" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {current.question}
            </h2>
            {current.subtitle && <p className="text-sm text-slate-500 mt-1">{current.subtitle}</p>}
          </div>

          {/* Image cards */}
          {current.type === 'image-cards' && (
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
              {current.options.map(opt => (
                <ImageCard key={opt.key} opt={opt}
                  selected={current.multi ? (answers[current.id] || []).includes(opt.key) : answers[current.id] === opt.key}
                  onClick={() => selectOption(current.id, opt.key, current.multi)}
                />
              ))}
            </div>
          )}

          {/* Cards */}
          {current.type === 'cards' && (
            <div className="flex flex-wrap gap-3">
              {current.options.map(opt => {
                const sel = answers[current.id] === opt.key;
                return (
                  <button key={opt.key} onClick={() => selectOption(current.id, opt.key, false)}
                    data-testid={`rq-option-${opt.key}`}
                    className={`px-5 py-3 rounded-lg border-2 text-sm font-medium transition-all cursor-pointer ${
                      sel ? 'border-[#2E7CF6] bg-[#2E7CF6]/5 text-[#1B5FD4]' : 'border-slate-200 text-slate-700 hover:border-slate-300'
                    }`}>
                    <span className={`inline-flex items-center justify-center w-5 h-5 rounded text-[10px] font-bold mr-2 ${sel ? 'bg-[#2E7CF6] text-white' : 'bg-slate-200 text-slate-500'}`}>{opt.key}</span>
                    {opt.label}
                  </button>
                );
              })}
            </div>
          )}

          {/* List */}
          {current.type === 'list' && (
            <div className="space-y-2">
              {current.options.map(opt => {
                const multi = current.multi;
                const sel = multi ? (answers[current.id] || []).includes(opt.key) : answers[current.id] === opt.key;
                return (
                  <button key={opt.key} onClick={() => selectOption(current.id, opt.key, multi)}
                    data-testid={`rq-option-${opt.key}`}
                    className={`w-full flex items-center gap-3 px-5 py-4 rounded-lg border-2 text-left transition-all cursor-pointer ${
                      sel ? 'border-[#2E7CF6] bg-[#2E7CF6]/5' : 'border-slate-200 hover:border-slate-300'
                    }`}>
                    <span className={`inline-flex items-center justify-center w-6 h-6 rounded text-xs font-bold shrink-0 ${sel ? 'bg-[#2E7CF6] text-white' : 'bg-slate-200 text-slate-500'}`}>{opt.key}</span>
                    <span className="text-sm font-medium text-slate-900">{opt.label}</span>
                  </button>
                );
              })}
            </div>
          )}

          {/* Email */}
          {current.type === 'email' && (
            <div className="max-w-lg">
              <input type="email" value={emailValue}
                onChange={(e) => setEmailValue(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && emailValue.includes('@') && setStep(s => s + 1)}
                placeholder={current.placeholder}
                data-testid="rq-email-input"
                className="w-full bg-slate-50 border-b-2 border-slate-300 outline-none text-lg py-3 px-1 text-slate-900 placeholder:text-slate-400 focus:border-[#2E7CF6]"
                autoFocus required
              />
            </div>
          )}

          {/* Contact */}
          {current.type === 'contact' && (
            <div className="max-w-lg space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-2">Vorname *</label>
                  <input type="text" value={contactName} data-testid="rq-contact-name"
                    onChange={(e) => { setContactName(e.target.value); setErrors(p => ({ ...p, name: null })); }}
                    placeholder="Max"
                    className={`w-full bg-slate-50 border-b-2 outline-none text-lg py-3 px-1 text-slate-900 placeholder:text-slate-400 ${errors.name ? 'border-red-400' : 'border-slate-300 focus:border-[#2E7CF6]'}`}
                    autoFocus required
                  />
                  {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-2">Nachname *</label>
                  <input type="text" value={contactLastName} data-testid="rq-contact-lastname"
                    onChange={(e) => { setContactLastName(e.target.value); setErrors(p => ({ ...p, lastName: null })); }}
                    placeholder="Mustermann"
                    className={`w-full bg-slate-50 border-b-2 outline-none text-lg py-3 px-1 text-slate-900 placeholder:text-slate-400 ${errors.lastName ? 'border-red-400' : 'border-slate-300 focus:border-[#2E7CF6]'}`}
                    required
                  />
                  {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-600 mb-2">Telefonnummer *</label>
                <input type="tel" value={contactPhone} data-testid="rq-contact-phone"
                  onChange={(e) => { setContactPhone(e.target.value); setErrors(p => ({ ...p, phone: null })); }}
                  onKeyDown={(e) => e.key === 'Enter' && contactName.trim() && contactLastName.trim() && contactPhone.trim() && handleSubmit()}
                  placeholder="+41 79 123 45 67"
                  className={`w-full bg-slate-50 border-b-2 outline-none text-lg py-3 px-1 text-slate-900 placeholder:text-slate-400 ${errors.phone ? 'border-red-400' : 'border-slate-300 focus:border-[#2E7CF6]'}`}
                  required
                />
                {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
              </div>
              <p className="text-xs text-slate-400">* Pflichtfelder</p>
            </div>
          )}

          {/* Actions */}
          <div className="mt-4 sm:mt-8">
            {/* Multi OK */}
            {current.multi && (answers[current.id] || []).length > 0 && (
              <button onClick={() => setStep(s => s + 1)} data-testid="rq-ok-multi"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#2E7CF6] to-[#1B5FD4] text-white font-bold text-sm rounded-md hover:opacity-90 transition-all mr-3">
                OK <Check className="w-4 h-4" />
              </button>
            )}
            {/* Email OK */}
            {current.type === 'email' && emailValue.includes('@') && (
              <button onClick={() => setStep(s => s + 1)} data-testid="rq-ok"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#2E7CF6] to-[#1B5FD4] text-white font-bold text-sm rounded-md hover:opacity-90 transition-all mr-3">
                OK <Check className="w-4 h-4" />
              </button>
            )}
            {/* Submit */}
            {current.type === 'contact' && (
              <button onClick={handleSubmit} disabled={submitting} data-testid="rq-submit"
                className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-[#2E7CF6] to-[#1B5FD4] text-white font-bold text-sm rounded-md hover:opacity-90 transition-all disabled:opacity-40 mr-3">
                {submitting ? <><Loader2 className="w-4 h-4 animate-spin" /> Wird gesendet...</> : <>Absenden <ArrowRight className="w-4 h-4" /></>}
              </button>
            )}
            {/* Back */}
            {step > 0 && (
              <button onClick={() => setStep(s => s - 1)}
                className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-slate-600 transition-colors mt-4">
                <ArrowLeft className="w-4 h-4" /> Zurück
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
